import type { LocalDate } from "@js-joda/core";
import { DateTimeFormatter } from "@js-joda/core";
import type { EnumDateFormat } from "@/app/services/generated/enums/enumDateFormat.generated";

const dateFormatToString = (dateFormat: EnumDateFormat) => {
  if (dateFormat.isYYYYMMDD()) {
    return "yyyy/MM/dd";
  }
  if (dateFormat.isDDMMYYYY()) {
    return "dd/MM/yyyy";
  }
  if (dateFormat.isDDMMYY()) {
    return "dd/MM/yy";
  }
  if (dateFormat.isMMDDYYYY()) {
    return "MM/dd/yyyy";
  }
  if (dateFormat.isMMDDYY()) {
    return "MM/dd/yy";
  } else {
    throw new Error("EnumDateFormat has invalid value " + dateFormat.value);
  }
};

const formatter = (dateFormat: EnumDateFormat) =>
  DateTimeFormatter.ofPattern(dateFormatToString(dateFormat));

const formatDate = (date: LocalDate, dateFormat: EnumDateFormat) =>
  formatter(dateFormat).format(date);

const dateTimes = {
  formatter,
  formatDate,
};

export { dateTimes };
